import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from './supabaseClient';
import { Card, Button, CircularProgress, Collapse, Pagination, Tabs, Tab, Box } from '@mui/material';
import MDTypography from 'components/MDTypography';
import DataNotFound from 'components/NoData/dataNotFound';
import MDBox from 'components/MDBox';
import noDataImage from "assets/images/illustrations/noData3.svg";


import { Tooltip, PieChart, Pie, Cell, Legend } from 'recharts';
import axios from 'axios';

export default function ViewEventRegistrations() {
    const { id } = useParams();
    const apiUrl = process.env.REACT_APP_API_BASE_URL;
    const bearerToken = localStorage.getItem('token');
    const [eventRegistrationData, setEventRegistrationData] = useState([]);
    const [registrationFormData, setRegistrationFormData] = useState([]);
    const [expandedId, setExpandedId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [selectedTab, setSelectedTab] = useState(0);
    const [textData, setTextData] = useState([]);
    const [pieData, setPieData] = useState([]);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const fetchEventRegistrations = async () => {
        try {
            const response = await axios.get(`${apiUrl}event-service/event-registration`, { params: { event: id, limit: rowsPerPage, page: currentPage } })
            if (response.data.success && response.data.data) {
                setEventRegistrationData(response.data.data);
                generateStatistics(response.data.data);
                setTotalPages(response.data.totalPages);
            }
        } catch (error) {
            console.log(error || error.response.message);
        }
    };

    const fetchRegistrationForm = async () => {
        try {
            const response = await axios.get(`${apiUrl}event-service/registration-form`, { params: { event: id } });
            if (response.data?.success && response.data?.data) {
                setRegistrationFormData(response.data?.data);
            } else {
                throw new Error("Failed to fetch fields");
            }
        } catch (error) {
            console.log(error.response?.data?.message || error.message);
        }
    };

    useEffect(() => {
        fetchEventRegistrations();
        fetchRegistrationForm();
        setTimeout(() => {
            setIsLoading(false);
        }, 500);
    }, [id, currentPage, selectedTab],);

    const allKeysOfRegisteredEvents = [...new Set(eventRegistrationData.flatMap(item => Object.keys(item.details)))];
    const allKeysOfForm = [...new Set(registrationFormData.map(item => (item.name)))];
    const matchingKeys = allKeysOfRegisteredEvents.filter(key => allKeysOfForm.includes(key) && key !== 'id');

    const toggleExpand = (cardId) => {
        setExpandedId(expandedId === cardId ? null : cardId);
    };

    const handlePageChange = (event, value) => {
        console.log('value', value)
        setCurrentPage(value);
        setIsLoading(true);
        fetchEventRegistrations();
    };

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const generateStatistics = (registrations) => {
        const textCounts = {};
        const pieCounts = {};
        const colorPalette = ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40", "#008080", "#FF7F50", "#DAA520"];

        registrations.forEach(item => {
            const details = (item.details);
            registrationFormData.forEach(formField => {
                const fieldValue = details[formField.name];
                const normalizedValue = fieldValue;

                if (['text', 'phone', 'email'].includes(formField.type)) {
                    if (normalizedValue) {
                        textCounts[formField.name] = textCounts[formField.name] || {};
                        textCounts[formField.name][normalizedValue] = (textCounts[formField.name][normalizedValue] || 0) + 1;
                    }
                }

                if (['radio', 'select'].includes(formField.type)) {
                    const options = formField.options.split(',').map(opt => opt.trim());
                    if (options.includes(normalizedValue)) {
                        pieCounts[formField.name] = pieCounts[formField.name] || {};
                        pieCounts[formField.name][normalizedValue] = (pieCounts[formField.name][normalizedValue] || 0) + 1;
                    }
                }
            });
        });


        const textDataList = Object.entries(textCounts).map(([fieldName, values]) => ({
            fieldName,
            values: Object.entries(values).map(([value, count]) => ({ value, count })),
        }));
        setTextData(textDataList);


        const pieDataList = Object.entries(pieCounts).map(([fieldName, values]) => {
            const options = registrationFormData.find(formField => formField.name === fieldName)?.options.split(',').map(opt => opt.trim()) || [];
            const data = options.map((option, index) => ({
                name: option,
                count: values[option] || 0,
                color: colorPalette[index % colorPalette.length],
            }));

            options.forEach((option, index) => {
                if (!values[option]) {
                    data.push({ name: option, count: 0, color: colorPalette[index % colorPalette.length] });
                }
            });

            return { fieldName, data };
        });
        setPieData(pieDataList);
        setIsLoading(false);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            <Card sx={{ p: 2, mb: 3, mt: 2 }}>
                <Tabs
                    value={selectedTab}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                >
                    <Tab label="Registered Informations" />
                    <Tab label="Statistical Representation" />
                </Tabs>
            </Card>

            {selectedTab === 0 && (
                <Card sx={{ p: 2, mb: 3 }}>
                    <MDTypography variant='h5' mb={1} fontWeight='medium'>Registered Informations</MDTypography>

                    {isLoading ? (
                        <MDBox p={3} display="flex" justifyContent="center">
                            <CircularProgress color="info" />
                        </MDBox>
                    ) : (eventRegistrationData && eventRegistrationData.length > 0) && (registrationFormData && registrationFormData.length > 0) ? (
                        <>
                            {eventRegistrationData.map((item, index) => {
                                const details = item.details;
                                const name = details["Full Name"] || (details["First Name"] && details["Last Name"] ? `${details["First Name"]} ${details["Last Name"]}` : details["Name"]) || "N/A";

                                return (
                                    <Card key={index} sx={{ mb: 2, p: 2, }}>
                                        <MDTypography variant="h6">
                                            ID: {item.id}
                                        </MDTypography>
                                        <MDTypography variant="body1">
                                            Name: {name}
                                        </MDTypography>

                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            onClick={() => toggleExpand(item.id)}
                                            sx={{
                                                mt: 2,
                                                width: '12px',
                                                fontSize: '0.75rem',
                                                color: 'white !important'
                                            }}
                                        >
                                            {expandedId === item.id ? "Less" : "More"}
                                        </Button>

                                        <Collapse in={expandedId === item.id}>
                                            <MDBox mt={2} mb={4}>
                                                {matchingKeys.map(key => (
                                                    <MDTypography key={key} variant="body2">
                                                        <strong>{key}:</strong> {details[key] || '--'}
                                                    </MDTypography>
                                                ))}
                                            </MDBox>
                                        </Collapse>
                                    </Card>
                                );
                            })}

                            <MDBox display="flex" justifyContent="right" mt={2}>
                                <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    color="standard"
                                    siblingCount={1}
                                    boundaryCount={1}
                                />
                            </MDBox>
                        </>
                    ) : (
                        <DataNotFound message={'No Entries Yet!'} image={noDataImage} />
                    )}
                </Card>
            )}

            {isLoading ? (
                <MDBox p={3} display="flex" justifyContent="center">
                    <CircularProgress color="info" />
                </MDBox>
            ) : (
                selectedTab === 1 && (
                    <Card sx={{ p: 2, mb: 3 }}>
                        {/* Text Data Section */}
                        <MDTypography variant="h4" mt={1} >Responses</MDTypography>

                        {textData.map((field, index) => (
                            <Card key={index} sx={{ p: 2, mb: 3, mt: 2, width: '50%' }}>
                                <MDTypography variant="h5" mb={1}>{field.fieldName}</MDTypography>
                                <MDBox
                                    sx={{
                                        maxHeight: 300,
                                        overflowY: 'auto',
                                        border: '1px solid #ccc',
                                        borderRadius: 1,
                                        p: 1,
                                    }}
                                >
                                    {field.values.map((value, idx) => (
                                        <MDTypography key={idx} variant="body2" sx={{ mb: 1 }}>
                                            {value.value} ({value.count})
                                        </MDTypography>
                                    ))}
                                </MDBox>
                            </Card>
                        ))}

                        {/* Pie Chart Section */}
                        {pieData.map((field, index) => (
                            <Card key={index} sx={{ p: 2, mb: 3, mt: 2, width: '50%' }}>
                                <MDTypography variant="h5" mt={1} mb={3}>{field.fieldName}</MDTypography>
                                <PieChart width={450} height={450} >
                                    <Pie
                                        data={field.data}
                                        dataKey="count"
                                        nameKey="name"
                                        cx="50%"
                                        cy="50%"
                                        outerRadius={150}
                                        fill="#b85994"
                                        label

                                    >
                                        {field.data.map((entry, idx) => (
                                            <Cell key={`cell-${idx}`} fill={entry.color} />
                                        ))}
                                    </Pie>
                                    <Tooltip />
                                    <Legend />
                                </PieChart>
                            </Card>
                        ))}
                    </Card>
                )
            )}
            <Footer />
        </DashboardLayout>
    );
}
